'use client'

import React from 'react'
import { motion } from 'framer-motion'
import { cn } from '@/lib/utils'

interface GradientTextProps {
  children: React.ReactNode
  className?: string
  gradient?: string
  animate?: boolean
  duration?: number
}

export default function GradientText({
  children,
  className,
  gradient = 'from-primary via-primary/80 to-primary/60',
  animate = true,
  duration = 3,
}: GradientTextProps) {
  return (
    <motion.span
      className={cn(
        'bg-gradient-to-r bg-clip-text text-transparent',
        gradient,
        className
      )}
      initial={animate ? { backgroundPosition: '0% 50%' } : false}
      animate={
        animate
          ? {
              backgroundPosition: ['0% 50%', '100% 50%', '0% 50%'],
            }
          : false
      }
      transition={
        animate
          ? {
              duration,
              ease: 'linear',
              repeat: Infinity,
            }
          : undefined
      }
      style={{
        backgroundSize: animate ? '200% 200%' : '100% 100%',
      }}
    >
      {children}
    </motion.span>
  )
}